export default {"src":"/_next/static/media/parts-diagram.68741125.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};